import React from 'react';
import { Row, Col } from 'reactstrap';
import PredicateLegend from '../../Index/Components/PredicateLegend';

const DetailHeaderCard = ({ data }) => {
  const employee = data?.employee || {
    nama: 'Alvian Yusuf Mizan, A.Md.Ak.',
    nip: '200001132023021003',
    jabatan: 'Pengolah Data dan Informasi',
    unitKerja: 'Biro Sumber Daya Manusia dan Organisasi',
    level: 'Level 4',
  };

  const scores = data?.scores || {
    nilaiKeseluruhan: '22.4',
    predikatKeseluruhan: 'Sangat Kurang',
    predikatKeseluruhanId: 'sangat-kurang',
    berAkhlak360: '22.27',
    predikatBerAkhlak: 'Sangat Kurang',
    predikatBerAkhlakId: 'sangat-kurang',
  };

  return (
    <div className="mb-4">
      <Row className="g-3 mb-3">
        {/* Left: Employee Info */}
        <Col lg={7}>
          <div className="p360-detail-profile-box">
            <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
              <h5 className="mb-0 fw-bold text-dark" style={{ fontSize: '1.25rem' }}>
                {employee.nama}
              </h5>
              <span className="p360-cat-badge">{employee.level || 'Level 4'}</span>
            </div>
            <div className="text-muted small mb-1" style={{ fontWeight: 500 }}>
              NIP: {employee.nip}
            </div>
            <div className="text-muted small">
              {employee.jabatan} - {employee.unitKerja}
            </div>
          </div>
        </Col>

        {/* Right: Score KPIs */}
        <Col lg={5}>
          <div className="p360-detail-score-box">
            {/* Nilai Keseluruhan */}
            <div className="p360-score-tile">
              <div className="p360-score-tile-label">Nilai Keseluruhan</div>
              <div className="p360-score-tile-value">{scores.nilaiKeseluruhan}</div>
              <span className={`p360-badge ${scores.predikatKeseluruhanId || 'sangat-kurang'}`}>
                {scores.predikatKeseluruhan}
              </span>
            </div>

            <div style={{ width: '1px', height: '60px', backgroundColor: '#e2e8f0' }}></div>

            {/* BerAkhlak 360 */}
            <div className="p360-score-tile">
              <div className="p360-score-tile-label">BerAkhlak 360</div>
              <div className="p360-score-tile-value">{scores.berAkhlak360}</div>
              <span className={`p360-badge ${scores.predikatBerAkhlakId || 'sangat-kurang'}`}>
                {scores.predikatBerAkhlak}
              </span>
            </div>
          </div>
        </Col>
      </Row>

      {/* Legend below profile */}
      <PredicateLegend />
    </div>
  );
};

export default DetailHeaderCard;
